
import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data = null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/remission-payments?${queryString}`;
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/remission-payments/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/remission-payments`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/remission-payments/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/remission-payments/${id}`, { headers: authHeader() });
    },
};
